import type { Injector } from '@angular/core';
import { inject } from '@angular/core';

import { TranslateService, TranslateStore } from '@ngx-translate/core';
import { assertInjector } from 'ngxtension/assert-injector';

export type TranslationKeyExists = (key: string) => boolean;

/**
 * Whether `key` is translated in the current or the fallback language. The
 * returned function reads the translate store's signals, so a `computed`
 * calling it re-runs when translations load or the language switches.
 */
export function injectTranslationKeyExists(
	injector?: Injector,
): TranslationKeyExists {
	return assertInjector(injectTranslationKeyExists, injector, () => {
		const translate = inject(TranslateService);
		const store = inject(TranslateStore);

		return (key: string) =>
			[translate.currentLang(), translate.fallbackLang()].some(
				(lang) =>
					lang !== null &&
					store.getTranslationValue(lang, key) !== undefined,
			);
	});
}
